import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NovaProcjena from './procjena_components/NovaProcjena';

const styles = {};

class Procjena extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <NovaProcjena history={this.props.history} />;
    }
}

Procjena.propTypes = {
    history: PropTypes.object.isRequired
};

let mapStateToProps = function(state, ownProps) {
    return {};
};

let mapDispatchToProps = function(dispatch) {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Procjena);
